/**
 * List of events used by booking item widget
 *
 */
export const bookingItem = {
  BOOKING_ITEM_DATA_CHANGED: 'BookingItem.DataChanged',
  BOOKING_ITEM_LOADED: 'BookingItem.Loaded',
  BOOKING_ITEM_SERVICE_AVAILABLE: 'BookingItem.ServiceAvailable'
}
